import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const SvgInfo = ({ className, ...props }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={classNames('svg', 'svg-info', className)}
    {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      stroke="#e7e7e7"
      d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z"
      fill="#F7F7F7"
    />
    <path fillRule="evenodd" clipRule="evenodd" fill="#999999" d="M9 12H7V7H9V12Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#999999"
      d="M8 6C7.44615 6 7 5.55385 7 5C7 4.44615 7.44615 4 8 4C8.55385 4 9 4.44615 9 5C9 5.55385 8.55385 6 8 6Z"
    />
  </svg>
);

SvgInfo.propTypes = {
  className: PropTypes.string,
};

export default SvgInfo;
